import { tap } from 'rxjs/operators';

export function throwIf<T>(predicate: (value: T) => boolean, message: string) {
  return tap<T>(x => {
    if (predicate(x)) throw new Error(message);
  });
}
